import React, { useEffect, useState } from 'react'
import Appbar from 'components/Appbar'
import Categories from './Categories'
import AvailableSection from './AvailableSection'
import ActiveSection from './ActiveSection'
import ActiveModal from './ActiveModal'
import AvailableModal from './AvailableModal'
import useIntegrations from './hooks/userIntegrations'
import { IIntegrationHash, IIntegration } from '@api/integration/types'
import IntegrationsSearch from './IntegrationsSearch'
import { PageContent, Flex, IconButton } from '@ui'
import track from '@track'
import Event from '@track/Event'
import { Classes } from '@blueprintjs/core'
import { legacyMode } from 'App'
import { navigateToAphrodite } from '@utils/navigateToAphrodite'
import Settings from 'components/NewSettings/Settings'

const formatAvailable = (available: IIntegration[]) =>
  available.reduce((groups: IIntegrationHash, integration: IIntegration) => {
    if (!groups[integration.category]) {
      groups[integration.category] = []
    }

    groups[integration.category].push(integration)

    return groups
  }, {})

enum CATEGORIES {
  ALL = 'All',
  API_DOCUMENTATION = 'API_Documentation',
  INTEGRATIONS = 'integrations',
}
export default function Integrations({ id }: { id: string }) {
  const DEFAULT_CATEGORIE = id ? id : CATEGORIES.ALL
  const [activeSection, setActiveSection] = useState(decodeURIComponent(DEFAULT_CATEGORIE))
  const [activeIntegration, setActiveIntegration] = useState<IIntegration | null>(null)
  const [availableIntegration, setAvailableIntegration] = useState<IIntegration | null>(null)
  const integrations = useIntegrations()

  useEffect(() => {
    setActiveSection(decodeURIComponent(DEFAULT_CATEGORIE))
  }, [DEFAULT_CATEGORIE])
  return (
    <>
      <Appbar
        title={
          legacyMode ? (
            <div className="flex items-center">
              <span className="mr-2">
                <IconButton
                  minimal
                  iconName="chevron-left"
                  onClick={() => navigateToAphrodite('/settings')}
                />
              </span>
              Integrations
            </div>
          ) : (
            'Integrations'
          )
        }
      >
        {activeSection !== CATEGORIES.API_DOCUMENTATION && (
          <IntegrationsSearch
            onSelect={(integraton: any) => {
              track.integration({ eventName: Event.SEARCH_RESULT_CLICK })
              setAvailableIntegration(integraton)
            }}
            integrations={integrations ? integrations.available : []}
          />
        )}
      </Appbar>
      <PageContent>
        {activeSection === CATEGORIES.API_DOCUMENTATION ? (
          <Settings id={CATEGORIES.INTEGRATIONS} />
        ) : (
          <Flex align="flex-start" style={{ paddingTop: 24 }}>
            {integrations.loading ? (
              <>
                {legacyMode && (
                  <Categories
                    setActive={setActiveSection}
                    activeSection={activeSection}
                    availableByCategories={fauxDefinition}
                    loading={true}
                  />
                )}
                <div style={{ paddingLeft: 24, width: 'calc(100% - 260px)' }}>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 'bold',
                      marginBottom: 25,
                    }}
                  >
                    <span className={Classes.SKELETON}>Active</span>
                  </div>
                  <AvailableSection
                    available={formatAvailable(fauxDefinition.SOMETHING1)}
                    activeSection={CATEGORIES.ALL}
                    setAvailableIntegration={setAvailableIntegration}
                    loading
                  />
                </div>
              </>
            ) : (
              <>
                {legacyMode && (
                  <Categories
                    setActive={setActiveSection}
                    activeSection={activeSection}
                    availableByCategories={formatAvailable(integrations.available)}
                  />
                )}

                <div style={{ paddingLeft: 24, width: 'calc(100% - 260px)' }}>
                  {integrations && (
                    <>
                      <ActiveSection
                        activeSection={activeSection}
                        active={integrations.active}
                        setActiveIntegration={(integration: IIntegration | null) => {
                          track.integration({
                            eventName: Event.EDIT_RECORD_DIALOG,
                            props: { name: integration?.name },
                          })
                          setActiveIntegration(integration)
                        }}
                      />
                      {activeIntegration && (
                        <ActiveModal
                          isOpen={!!activeIntegration}
                          onClose={() => setActiveIntegration(null)}
                          integration={activeIntegration}
                          regenerateToken={integrations.regenerateToken}
                          disableIntegration={integrations.disableIntegration}
                          updateIntegration={integrations.updateIntegration}
                          sendSlackInstructions={integrations.sendSlackInstructions}
                        />
                      )}
                    </>
                  )}
                  {integrations && (
                    <>
                      <AvailableSection
                        activeSection={activeSection}
                        available={formatAvailable(integrations.available)}
                        setAvailableIntegration={(integration: IIntegration | null) => {
                          track.integration({
                            eventName: Event.NEW_RECORD_DIALOG,
                            props: { name: integration?.name },
                          })
                          setAvailableIntegration(integration)
                        }}
                      />
                      {availableIntegration && (
                        <AvailableModal
                          isOpen={!!availableIntegration}
                          onClose={() => setAvailableIntegration(null)}
                          integration={availableIntegration}
                          enableIntegration={integrations.enableIntegration}
                        />
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </Flex>
        )}
      </PageContent>
    </>
  )
}

// let fauxCategories = [
//   'SOMETHING1',
//   'SOMETHING2',
//   'SOMETHING3',
//   'SOMETHING4',
//   'SOMETHING5',
//   'SOMETHING6',
//   'SOMETHING7',
//   'SOMETHING8',
// ]

const fauxDefinition: IIntegrationHash = {
  SOMETHING1: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING1',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
    {
      id: '2',
      name: 'SOMETHINGB',
      image: '',
      category: 'SOMETHING1',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
    {
      id: '3',
      name: 'SOMETHINGC',
      image: '',
      category: 'SOMETHING1',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
    {
      id: '4',
      name: 'SOMETHINGD',
      image: '',
      category: 'SOMETHING1',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
    {
      id: '5',
      name: 'SOMETHINGE',
      image: '',
      category: 'SOMETHING1',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
    {
      id: '6',
      name: 'SOMETHINGF',
      image: '',
      category: 'SOMETHING1',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
  SOMETHING2: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING2',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
  SOMETHING3: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING3',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
  SOMETHING4: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING4',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
  SOMETHING5: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING5',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
  SOMETHING6: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING6',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
  SOMETHING7: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING7',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
  SOMETHING8: [
    {
      id: '1',
      name: 'SOMETHINGA',
      image: '',
      category: 'SOMETHING8',
      description: 'A bunch of words that should not be seen by anyone',
      source: 'abracadabra',
      applications: [],
    },
  ],
}
